export var EOrderProductPortInOldSubscriptionType;
(function (EOrderProductPortInOldSubscriptionType) {
    EOrderProductPortInOldSubscriptionType[EOrderProductPortInOldSubscriptionType["Prepaid"] = 0] = "Prepaid";
    EOrderProductPortInOldSubscriptionType[EOrderProductPortInOldSubscriptionType["PostpaidPrivate"] = 1] = "PostpaidPrivate";
    EOrderProductPortInOldSubscriptionType[EOrderProductPortInOldSubscriptionType["PostpaidCompany"] = 2] = "PostpaidCompany";
    EOrderProductPortInOldSubscriptionType[EOrderProductPortInOldSubscriptionType["__LENGTH"] = 3] = "__LENGTH";
})(EOrderProductPortInOldSubscriptionType || (EOrderProductPortInOldSubscriptionType = {}));
